export default "__VITE_ASSET__DPgdsWQ6__"